<div class="max-w-[420px] w-full relative">
  <h5 class="p-7 pb-3 text-lg font-semibold d-flex justify-content-between">
    <span>{{ 'file already exists' | translate }}</span>
    <span (click)="onCancel()">
      <i-tabler name="x" class="icon-20 w-8 d-flex rounded cursor-pointer aspect-square hover:bg-[var(--mat-color-light-table-hover)] hover:text-[var(--mat-sys-primary)] dark:hover:bg-[var(--striped-row-background-color)] dark:hover:text-[var(--mat-color-primary)]"/>
    </span>
  </h5>

  <div class="px-7">
  <div class="conflict-list">
      @for (name of config.conflicts; track name) {
        <div class="conflict-item">{{ name }}</div>
      }
    </div>
    <p class="conflict-hint">{{ 'keep both hint' | translate }}</p>
  </div>

  <div mat-dialog-actions class="mt-2 px-7 pb-2 flex items-center justify-end gap-3" style="border-top: none">
    <button mat-stroked-button (click)="onResolve('keepBoth')" class="rounded-md h-[36px]!">
      {{ 'keep both' | translate }}
    </button>
    <button mat-flat-button color="primary" (click)="onResolve('overwrite')" class="rounded-md h-[36px]!">
      {{ 'overwrite' | translate }}
    </button>
  </div>
</div>
